import { render } from "./PastTripsPage.vue?vue&type=template&id=66735d98&scoped=true&ts=true"
import script from "./PastTripsPage.vue?vue&type=script&lang=ts"
export * from "./PastTripsPage.vue?vue&type=script&lang=ts"

import "./PastTripsPage.vue?vue&type=style&index=0&id=66735d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66735d98"]])

export default __exports__